import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { NextSeo } from "next-seo";
import { useResolveAwsImgPath } from "../../utils";
import { useConfig } from "../Config/ConfigContext";
export const UserPublicProfileSeo = (param)=>{
    let { user  } = param;
    const { pageUrl  } = useConfig();
    return /*#__PURE__*/ _jsx(NextSeo, {
        title: user.name,
        defaultTitle: user.name,
        titleTemplate: user.name,
        description: user.description || undefined,
        openGraph: {
            url: "".concat(pageUrl, "/users/").concat(user.cognito_id),
            ...user.avatar_url ? {
                images: [
                    {
                        url: useResolveAwsImgPath(user.avatar_url),
                        width: 601,
                        height: 601,
                        secureUrl: useResolveAwsImgPath(user.avatar_url),
                        alt: user.name
                    }
                ]
            } : undefined
        }
    });
};
